import { createRouter, createWebHistory } from 'vue-router'
import store from '@/store';

import Login from '../views/login.vue'
import Requests from '../views/requests.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: Requests,
    meta: { requiresAuth: true }
  },
  {
    path: '/login/',
    name: 'login',
    component: Login,
    meta: { requiresAuth: false }
  },

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to) => {

  //проверка необходимости авторизации
  if (to.meta.requiresAuth && !store.getters.isAuthorized) {
    return {
      path: '/login'
    }
  }


});

export default router
